/* KMALL09 — 픽업 전용 상품 장바구니 분리 (260729 도서용 신설 → 260831 프리오더로 확장)
   도서(handle book-* / SKU BOOK-*)와 프리오더 픽업 상품(SKU PO-* 또는 "프리오더" 컬렉션 소속,
   metafield kmall.checkout_pickup_only=true)은 매장에서 직접 받는 상품이라
   일반 상품과 한 주문으로 결제할 수 없다. 그래서 장바구니 자체를 상호 배타로 만든다.
   함수·변수명은 "book"을 그대로 쓰지만(도서용으로 처음 만들어져 리스크를 줄이려 이름을 안 바꿈)
   실제로는 "픽업 전용 그룹"을 뜻한다 — isBookItem/isBookUrl이 도서·프리오더를 모두 판별한다.

   3중 방어:
     1) 담기 단계 차단 — 카드/상품페이지/도서코너의 담기 동작을 캡처 단계에서 가로채,
        충돌하면 안내 모달을 띄우고 "보관함으로 옮기고 담기"를 제안한다.
     2) AJAX 폴백 — 위에서 못 잡은 경로(앱·PageFly 등)로 담긴 경우, 담긴 직후 되돌린다.
     3) 장바구니 페이지 최종 방어 — 그래도 섞였으면 결제 버튼을 막고 한쪽 정리 버튼을 준다.

   보관함(localStorage)에 옮겨둔 상품은 장바구니 페이지에서 한 번에 다시 담을 수 있다. */
(function () {
  var T = window.KM_BOOKCART_I18N || {};
  var STASH_KEY = 'km_cart_stash_v1';
  var bypass = false;

  function t(k, fallback) { return (T && T[k]) || fallback || ''; }

  /* ── 픽업 전용 판별(도서 + 프리오더) ─────────────────────────
     태그는 besir 동기화(자니터)가 덮어쓰므로 절대 기준으로 쓰지 않는다.
     정본 기준 = ①상품 handle 이 book- 으로 시작 ②SKU 가 BOOK- 또는 PO- 로 시작
     ③variant id 가 "프리오더" 컬렉션 소속(window.KM_PREORDER_VARIANT_IDS, theme.liquid 가 매 페이지
     주입 — 향후 회차(PO-R2 등)가 컬렉션에 들어오기만 하면 코드 수정 없이 자동 반영된다). */
  var PREORDER_IDS = window.KM_PREORDER_VARIANT_IDS || null; // Set<number> 또는 null(미주입)
  function isPreorderVariantId(id) {
    if (!PREORDER_IDS || id == null) return false;
    return PREORDER_IDS.has(Number(id));
  }
  function isBookItem(it) {
    var sku = String(it.sku || '').toUpperCase();
    if (sku.indexOf('BOOK-') === 0 || sku.indexOf('PO-') === 0) return true;
    if (String(it.handle || '').indexOf('book-') === 0) return true;
    return isPreorderVariantId(it.variant_id || it.id);
  }
  function isBookUrl(u) { return String(u || '').indexOf('/products/book-') >= 0; }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }
  function split(cart) {
    var books = [], others = [];
    (cart.items || []).forEach(function (it) { (isBookItem(it) ? books : others).push(it); });
    return { books: books, others: others, mixed: books.length > 0 && others.length > 0 };
  }

  /* ── 보관함 ───────────────────────────────────────────── */
  function readStash() {
    try {
      var v = JSON.parse(localStorage.getItem(STASH_KEY) || 'null');
      if (v && v.items && v.items.length) return v;
    } catch (e) {}
    return null;
  }
  function writeStash(kind, items) {
    var payload = { kind: kind, items: items.map(function (it) {
      return { id: it.variant_id || it.id, quantity: it.quantity, title: it.product_title || it.title || '' };
    }) };
    try { localStorage.setItem(STASH_KEY, JSON.stringify(payload)); } catch (e) {}
    return payload;
  }
  function clearStash() { try { localStorage.removeItem(STASH_KEY); } catch (e) {} }

  /* 주어진 라인들을 장바구니에서 순차 제거 (라인 key 기준 — 변형ID 중복에 안전) */
  function removeLines(items) {
    return items.reduce(function (chain, it) {
      return chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: it.key, quantity: 0 })
        });
      });
    }, Promise.resolve());
  }
  /* 한쪽 그룹을 보관함으로 옮긴다 (= 저장 + 장바구니에서 제거) */
  function stashGroup(kind, items) {
    writeStash(kind, items);
    return removeLines(items);
  }

  /* ── 모달 ─────────────────────────────────────────────── */
  function ensureStyle() {
    if (document.getElementById('km-bookcart-style')) return;
    var s = document.createElement('style');
    s.id = 'km-bookcart-style';
    s.textContent = [
      '.km-bcm{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;padding:18px;background:rgba(17,24,39,.55)}',
      '.km-bcm__box{background:#fff;border-radius:14px;max-width:460px;width:100%;padding:22px;font-family:var(--km-font,"Pretendard Variable",Pretendard,system-ui,sans-serif);color:#1F2937;box-sizing:border-box}',
      '.km-bcm__t{font-size:17px;font-weight:700;margin:0 0 8px;color:#0857C3}',
      '.km-bcm__b{font-size:14px;line-height:1.65;margin:0 0 6px;color:#374151}',
      '.km-bcm__n{font-size:13px;line-height:1.6;margin:10px 0 0;padding:10px 12px;background:#F3F4F6;border-radius:8px;color:#4B5563}',
      '.km-bcm__a{display:flex;flex-direction:column;gap:8px;margin-top:18px}',
      '.km-bcm__a button{width:100%;padding:12px 14px;border-radius:10px;font-size:14px;font-weight:600;cursor:pointer;font-family:inherit;border:1px solid transparent}',
      '.km-bcm__a .p{background:#0857C3;color:#fff}',
      '.km-bcm__a .g{background:#fff;color:#4B5563;border-color:#D1D5DB}',
      '.km-bcbar{margin:0 0 14px;padding:12px 14px;border-radius:10px;font-size:13.5px;line-height:1.6;display:flex;flex-wrap:wrap;gap:8px;align-items:center}',
      /* 그리드(.kmall-cart) 안에 들어간 경우 대비 — 한 줄 전체를 차지해 리스트/요약 칸을 밀지 않는다 */
      '.kmall-cart > .km-bcbar{grid-column:1/-1}',
      '.km-bcbar--stash{background:#F3F4F6;color:#374151}',
      '.km-bcbar--block{background:#FEF2F2;color:#991B1B;border:1px solid #FCA5A5}',
      '.km-bcbar b{font-weight:700}',
      '.km-bcbar button{margin-left:auto;padding:7px 12px;border-radius:8px;border:1px solid #0857C3;background:#0857C3;color:#fff;font-size:13px;font-weight:600;cursor:pointer;font-family:inherit}',
      '.km-bcbar button.g{background:#fff;color:#4B5563;border-color:#D1D5DB;margin-left:0}'
    ].join('');
    document.head.appendChild(s);
  }

  function modal(opt) {
    ensureStyle();
    var wrap = document.createElement('div');
    wrap.className = 'km-bcm';
    var box = document.createElement('div');
    box.className = 'km-bcm__box';
    var h = document.createElement('p'); h.className = 'km-bcm__t'; h.textContent = opt.title;
    var b = document.createElement('p'); b.className = 'km-bcm__b'; b.textContent = opt.body;
    box.appendChild(h); box.appendChild(b);
    if (opt.note) { var n = document.createElement('p'); n.className = 'km-bcm__n'; n.textContent = opt.note; box.appendChild(n); }
    var acts = document.createElement('div'); acts.className = 'km-bcm__a';
    (opt.actions || []).forEach(function (a) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = a.primary ? 'p' : 'g';
      btn.textContent = a.label;
      btn.addEventListener('click', function () { close(); if (a.run) a.run(); });
      acts.appendChild(btn);
    });
    box.appendChild(acts); wrap.appendChild(box);
    function close() { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    document.body.appendChild(wrap);
    return close;
  }

  /* ── 1) 담기 차단 ─────────────────────────────────────── */
  function conflictModal(addingBook, parts, proceed) {
    var moving = addingBook ? parts.others : parts.books;
    modal({
      title: addingBook ? t('title_book') : t('title_other'),
      body: addingBook ? t('body_book') : t('body_other'),
      note: t('stash_note'),
      actions: [
        {
          label: addingBook ? t('act_stash_other') : t('act_stash_book'),
          primary: true,
          run: function () {
            stashGroup(addingBook ? 'other' : 'book', moving).then(function () {
              bypass = true;
              try { proceed(); } finally { setTimeout(function () { bypass = false; }, 0); }
            });
          }
        },
        { label: t('act_cancel') }
      ]
    });
  }

  /* 충돌이면 true 를 돌려주고 모달을 띄운다 */
  function checkThen(addingBook, proceed) {
    getCart().then(function (cart) {
      var parts = split(cart);
      var conflict = addingBook ? parts.others.length > 0 : parts.books.length > 0;
      if (!conflict) {
        bypass = true;
        try { proceed(); } finally { setTimeout(function () { bypass = false; }, 0); }
        return;
      }
      conflictModal(addingBook, parts, proceed);
    }).catch(function () {
      bypass = true;
      try { proceed(); } finally { setTimeout(function () { bypass = false; }, 0); }
    });
  }

  document.addEventListener('click', function (e) {
    if (bypass) return;
    var card = e.target.closest && e.target.closest('[data-km-atc-add]');
    var book = e.target.closest && e.target.closest('[data-kmb-order]');
    var el = card || book;
    if (!el) return;
    var addingBook;
    if (book) addingBook = true;
    else {
      var w = card.closest('[data-km-atc]');
      addingBook = isBookUrl(w && w.getAttribute('data-km-url')) ||
        isPreorderVariantId(w && w.getAttribute('data-km-vid'));
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    checkThen(addingBook, function () { el.click(); });
  }, true);

  document.addEventListener('submit', function (e) {
    if (bypass) return;
    var form = e.target;
    if (!form || !form.getAttribute) return;
    var action = form.getAttribute('action') || '';
    if (form.id !== 'kmall-add' && action.indexOf('/cart/add') < 0) return;
    var idEl = form.querySelector('[name="id"]');
    var addingBook = isBookUrl(location.pathname) ||
      isPreorderVariantId(idEl && idEl.value);
    e.preventDefault();
    e.stopImmediatePropagation();
    checkThen(addingBook, function () {
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  }, true);

  /* ── 2) AJAX 폴백 — 우리가 못 잡은 경로로 담긴 경우 되돌린다 ── */
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isAdd = url.indexOf('/cart/add') >= 0;
      var p = origFetch.apply(this, arguments);
      if (!isAdd) return p;
      return p.then(function (res) {
        if (res && res.ok) setTimeout(reconcile, 60);
        return res;
      });
    };
  }
  var reconciling = false;
  function reconcile() {
    if (reconciling) return;
    reconciling = true;
    getCart().then(function (cart) {
      var parts = split(cart);
      if (!parts.mixed) return null;
      /* 어느 쪽이 나중에 담겼는지 모르므로, 수가 적은 쪽을 보관함으로 옮기고 알린다 */
      var moveBooks = parts.books.length <= parts.others.length;
      var moving = moveBooks ? parts.books : parts.others;
      return stashGroup(moveBooks ? 'book' : 'other', moving).then(function () {
        modal({
          title: t('title_other'),
          body: t('body_auto'),
          note: t('stash_note'),
          actions: [{ label: t('act_ok'), primary: true, run: function () { location.reload(); } }]
        });
      });
    }).catch(function () {}).then(function () { reconciling = false; });
  }

  /* ── 3) 장바구니 페이지 — 보관함 바 + 혼합 최종 차단 ──── */
  function cartRoot() { return document.querySelector('.kmall-cart .wrap') || document.querySelector('.kmall-cart'); }

  /* 안내 바는 장바구니 그리드 "바깥, 바로 위"에 붙인다.
     .kmall-cart 는 grid(1fr 360px) 라서 바를 그 안에 넣으면 바 자체가 그리드 아이템이 되어
     상품 리스트가 오른쪽 칸으로 밀리고 주문요약이 왼쪽 아래로 내려간다(260815 제보).
     그리드의 형제로 끼워 넣으면 원래 장바구니 프레임이 그대로 유지되고 바 아래로 리스트가 나온다.
     혹시 다른 마크업에서 바가 그리드 안에 들어가더라도 CSS 의 grid-column:1/-1 이 한 줄 전체를
     차지하게 해 프레임이 밀리지 않는다. */
  function bar(cls, text) {
    var root = cartRoot();
    if (!root) return null;
    ensureStyle();
    var d = document.createElement('div');
    d.className = 'km-bcbar ' + cls;
    var span = document.createElement('span');
    span.textContent = text;
    d.appendChild(span);
    if (root.parentNode) root.parentNode.insertBefore(d, root);
    else root.insertBefore(d, root.firstChild);
    return d;
  }

  function restoreStash() {
    var st = readStash();
    if (!st) return;
    var keep = st.items.slice();
    /* swapped=true 면 지금 장바구니 쪽이 새 보관분이 되었으므로 보관함을 비우지 않는다 */
    function go(swapped) {
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: keep.map(function (i) { return { id: i.id, quantity: i.quantity }; }) })
      }).then(function () {
        if (!swapped) clearStash();
        location.reload();
      });
    }
    getCart().then(function (cart) {
      var parts = split(cart);
      var conflicting = st.kind === 'book' ? parts.others : parts.books;
      if (!conflicting.length) { go(false); return; }
      modal({
        title: st.kind === 'book' ? t('title_book') : t('title_other'),
        body: t('body_swap'),
        actions: [
          {
            label: t('act_swap'), primary: true,
            run: function () {
              /* 지금 장바구니의 충돌 그룹을 보관함으로 교체 저장한 뒤, 보관분을 다시 담는다 */
              removeLines(conflicting).then(function () {
                writeStash(st.kind === 'book' ? 'other' : 'book', conflicting);
                go(true);
              });
            }
          },
          { label: t('act_cancel') }
        ]
      });
    });
  }

  function paintCartPage() {
    if (!cartRoot()) return;
    getCart().then(function (cart) {
      var parts = split(cart);

      if (parts.mixed) {
        var b = bar('km-bcbar--block', t('mixed_block'));
        if (b) {
          [['keep_book', true], ['keep_other', false]].forEach(function (pair) {
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.textContent = pair[0] === 'keep_book' ? t('fix_keep_book') : t('fix_keep_other');
            if (pair[0] !== 'keep_book') btn.className = 'g';
            btn.addEventListener('click', function () {
              var moveBooks = !pair[1];
              stashGroup(moveBooks ? 'book' : 'other', moveBooks ? parts.books : parts.others)
                .then(function () { location.reload(); });
            });
            b.appendChild(btn);
          });
        }
        document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          btn.style.opacity = '.45';
          btn.style.cursor = 'not-allowed';
        });
      }

      var st = readStash();
      if (st) {
        var sb = bar('km-bcbar--stash', st.items.length + t('stash_bar'));
        if (sb) {
          var r = document.createElement('button');
          r.type = 'button'; r.textContent = t('stash_restore');
          r.addEventListener('click', restoreStash);
          var c = document.createElement('button');
          c.type = 'button'; c.className = 'g'; c.textContent = t('stash_clear');
          c.addEventListener('click', function () { clearStash(); location.reload(); });
          sb.appendChild(r); sb.appendChild(c);
        }
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintCartPage);
  else paintCartPage();
})();
